import { Outlet } from 'react-router-dom';
import Header from './Header'
import Footer from './Footer'
const Layout = () => {
    return (
        <>
            <Header />
            <main>
                <Outlet /> {/* Just the Outlet, no Routes wrapper */}
            </main>
            <Footer />
        </>
    );
};
export default Layout